// import { useEffect, useState } from 'react';
import { Home, Login, Signup, Settings, UserProfile } from '../pages';
import { Loader, Navbar } from './';
// eslint-disable-next-line
import { BrowserRouter as Router, Routes, Route, Navigate,useNavigate, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks';

function PrivateRoute() {
  const navigate = useNavigate();
  const auth = useAuth();
  return auth.user ? <Outlet /> : navigate('/login');
}


const Page404 = () => {
  return <div style={{ padding: 20 }}><h1 style={{ textAlign: 'center' }}>Error:404 Page Not Found</h1></div>
}

function App() {
  // const [posts, setPosts] = useState([]);
  // const [Loading, setLoading] = useState(true);

  // useEffect(() => {
  //   const fetchPost = async () => {
  //     const response = await getPosts(1, 6);
  //     if (response.success) {
  //       setPosts(response.data.posts);
  //     }
  //     // console.log('response',response);
  //     setLoading(false);
  //   }
  //   fetchPost();
  // }, []);
  // document.addEventListener('contextmenu', event => event.preventDefault());

  const auth = useAuth();
  console.log('auth', auth);
  if (auth.Loading) {
    return <Loader />
  }

  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>

          <Route exact path='/' element={<Home posts={[]} />} />

          <Route exact path='/login' element={<Login />} />
          <Route exact path='/register' element={<Signup />} />

          <Route exact path='/settings' element={<PrivateRoute />}>
            <Route exact path='/settings' element={<Settings />}/>
          </Route>

          <Route exact path='/user/:userId' element={<PrivateRoute />}>
            <Route exact path='/user/:userId' element={<UserProfile />}/>
          </Route>
          {/* <Route exact path='/settings/*' element={
            auth.user ? <Settings /> : navigate('/login')
          } /> */}

          {/* <PrivateRoute exact path='/settings' >
            <Settings />
          </PrivateRoute> */}

          <Route path='/*' element={<Page404 />} />

        </Routes>
      </Router>
    </div>
  );
}

export default App;
